import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_OL_CHECKLIST } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolChecklistState extends EntityState<IID_OL_CHECKLIST, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_CHECKLIST })
@InterfaceDataStore(InterfaceName.CHECKLIST)
export class IIDolChecklistStore extends EntityStore<IIDolChecklistState> {
  constructor() {
    super([]);
  }
}
